var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "시설 및 참여",
      "tabActive": "시설소개",
      "bg": "/images/sub/visual/sv2.jpg"
    }
  }), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('dept3-tab', {
    attrs: {
      "page": "시설소개",
      "tabActive": "1"
    }
  }), _c('div', {
    staticClass: "tit-wrap"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold"
  }, [_vm._v("VR 스포츠 룸")])]), _c('div', {
    staticClass: "mb-50 mb-lg-80"
  }, [_c('center-top', {
    attrs: {
      "sc1": "“버커니어즈 VR 스포츠룸, 아이들의 또 다른 출발선.” <br>첨단 VR로 어디서도 못한 스포츠를 경험합니다.",
      "sc2": "안전한 미래 체험 <br>“기후·환경 제약 없이, 모두가 함께 즐기는 스포츠.” <br>안전하고 친환경적인 공간에서 배우고 성장합니다."
    }
  }, [_c('slide-primary', {
    attrs: {
      "slideNum": "1",
      "className": "pagination-top"
    }
  }, _vm._l(_vm.images, function (image, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticClass: "d-block w-100",
      attrs: {
        "src": image,
        "alt": ""
      }
    })]);
  }), 0)], 1)], 1), _c('div', {
    staticClass: "mb-50 mb-lg-80"
  }, [_c('v-row', _vm._l(_vm.items, function (item, index) {
    return _c('v-col', {
      key: index,
      staticClass: "mb-10 mb-lg-0",
      attrs: {
        "cols": "12",
        "sm": "6",
        "lg": "3"
      }
    }, [_c('num-item', {
      attrs: {
        "num": `0${index + 1}`
      }
    }, [_c('icon-primary', {
      attrs: {
        "className": "mb-10 mb-lg-20",
        "icon": item.icon,
        "maxWidth": "40"
      }
    }), _c('p', {
      staticClass: "page-text page-text--sm",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })], 1)], 1);
  }), 1)], 1), _c('div', {
    staticClass: "mb-50 mb-lg-74 w-100"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/center/vr/map.jpg"
    }
  })], 1), _c('h5', {
    staticClass: "tit--sm font-weight-bold mb-10 mb-lg-26"
  }, [_vm._v("찾아 오시는 길")]), _c('div', {
    staticClass: "pa-20 pa-ma-30 pa-lg-50 border border-color-light border-2 border-lg-4"
  }, [_c('div', {
    staticClass: "d-lg-flex align-center mb-12 mb-lg-20"
  }, [_c('p', {
    staticClass: "w-60px w-lg-100px py-4 page-text text-center bg-secon color-white mb-2 mb-lg-0 mr-12 mr-lg-40 font-weight-bold"
  }, [_vm._v("주소")]), _c('p', {
    staticClass: "color-grey page-text"
  }, [_vm._v("서울 강서구 강서로54길 93 1층")])]), _c('div', {
    staticClass: "d-lg-flex align-center"
  }, [_c('p', {
    staticClass: "w-60px w-lg-100px py-4 page-text text-center bg-secon color-white mb-2 mb-lg-0 mr-12 mr-lg-40 font-weight-bold"
  }, [_vm._v("대중교통")]), _c('div', {
    staticClass: "d-lg-flex align-center page-text"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('p', {
    staticClass: "font-weight-bold w-40px w-lg-auto mr-4 mr-lg-14"
  }, [_vm._v("지하철")]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', {
    staticClass: "dot mr-4 mr-lg-10",
    staticStyle: {
      "background-color": "#996cac"
    }
  }), _c('p', {
    staticClass: "color-grey"
  }, [_vm._v("5호선 발산역 기준 3,4번 출구 도보 630m (10분) 이동")])])])])])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }